import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { Button, Column, Row, Heading } from '../../Blocks'
import { closePopups } from '../../../utilities'

const ModalEmptyCart = () => {

  const handleClick = (e) => {
    closePopups(e);
    if (state.current.initialChoices.inhouseCode === null) {
      state.current.modal.open = true;
      state.current.modal.selectModel = true;

    }
  }

  const moveToReview = (e) => {
    closePopups(e);
    state.current.modal.open = true;
    state.current.modal.orderSummary = true;
  }

  return (
    <Column>

      {
        state.current.initialChoices.inhouseCode ?

          <>
            <Heading align="left">
              Please review your choices before adding to cart.
            </Heading>
            <Button fullWidth handleClick={(e) => moveToReview(e)}>Review Order</Button>

          </>



          : <>
            <Heading align="left">
              Please start designing to add 3D seats to your basket.
            </Heading>
            <Button fullWidth handleClick={(e) => handleClick(e)}>Start Designing</Button>

          </>
      }


    </Column>
  )
}

export default ModalEmptyCart

